export default Object.freeze({
  fa: 0,
  en: 1,
  es: 2,
  ar: 3,
  az: 4,
  ur: 5,
});
